import {
    START_LOADING_AXIOS,
    FINISH_LOADING_AXIOS,
    ERROR_LOADING_AXIOS
 } from './../../../constants/closeLoop/validation/index';

const initialState = {};

export const axiosReducer = (state=initialState, action) => {
    switch(action.type) {
        case START_LOADING_AXIOS:
            return {
                ...state,
                [action.queryString]: {
                    ...state[action.queryString],
                    loading: true,
                    error: ''
                }
            }

        case FINISH_LOADING_AXIOS:
            return {
                ...state,
                [action.queryString]: {
                    ...state[action.queryString],
                    loading: false,
                    error: '',
                    info: action.info
                }
            }

        case ERROR_LOADING_AXIOS:
            return {
                ...state,
                [action.queryString]: {
                    ...state[action.queryString],
                    loading: false,
                    error: action.payload
                }
            }

        default:
            return state;
    }
};